const ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz';
const ID_LENGTH = 12;

export function generateId(length: number = ID_LENGTH): string {
  let id = '';
  const bytes = crypto.getRandomValues(new Uint8Array(length));
  for (let i = 0; i < length; i++) {
    id += ALPHABET[bytes[i] % ALPHABET.length];
  }
  return id;
}

export function generateProjectId(): string {
  return `prj_${generateId()}`;
}

export function generateUserId(): string {
  return `usr_${generateId()}`;
}

export function generateRuleId(): string {
  return `rul_${generateId()}`;
}

export function generateShareLinkId(): string {
  return `sl_${generateId()}`;
}

export function generateGlobalVariableId(): string {
  return `gv_${generateId()}`;
}

export function generateProjectVariableId(): string {
  return `pv_${generateId()}`;
}

export function generateShareToken(): string {
  return generateId(24);
}

export function generateTeamInviteId(): string {
  return `tinv_${generateId()}`;
}

export function generateTeamId(): string {
  return `team_${generateId()}`;
}

export function generateNotificationId(): string {
  return `ntf_${generateId()}`;
}

/**
 * Turn a team name into a URL/DB-safe slug: lowercase, non-alphanumerics
 * collapsed to single hyphens, trimmed, capped at 40 chars. Falls back to a
 * random suffix when the name has no alphanumeric characters at all.
 */
export function slugify(name: string): string {
  const base = name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 40)
    .replace(/-+$/g, '');
  return base || `team-${generateId(8)}`;
}
